const externalLink = (label, href) => ({ label, href });

export const resourceNavigation = [
  {
    id: 'about',
    label: 'About iLEARN',
    links: [
      externalLink(
        'Mission & Advisory Committees',
        'https://usahs.sharepoint.com/sites/USAHSStudentResources/SitePages/About-iLEARN.aspx?csf=1&web=1&e=zExR0s'
      )
    ]
  },
  externalLink('Workshops and Recordings', 'https://ilearn.usa.edu/allvideos/'),
  externalLink('Office of Micro-Credentials', 'https://usahs.sharepoint.com/sites/USAHSMicro-Credentials'),
  {
    id: 'clinicalInnovation',
    label: 'Clinical Innovation',
    links: [
      externalLink('Innovation and Creation Hub', 'https://library.usa.edu/library-innovation-and-creation-hub'),
      externalLink('Centers for Innovative Clinical Practice', 'https://usahs.sharepoint.com/sites/CentersforInnovativeClinicalPractice'),
      externalLink('Pro Bono Clinical Experiences', 'https://usahs.sharepoint.com/sites/USAHSProBonoClinicalExperiences')
    ]
  },
  externalLink(
    'GEN AI Hub',
    'https://usahs.sharepoint.com/sites/USAHSStudentResources/SitePages/Generative-AI.aspx?CT=1753732220126&OR=OWA-NT-Mail&CID=42cf84d8-94e2-5690-5c74-7ea93d3d9e0e&csf=1&web=1&e=xiJ3Wv'
  ),
  externalLink(
    'NBCOT Success Hub',
    'https://usahs.sharepoint.com/sites/NBCOTSuccessHub/SitePages/OnboardingHome.aspx?d=w6715698e6610403b8270902986668191&csf=1&web=1&e=cO5qrC&CT=1788550739956&OR=OWA-NT-Mail&CID=34947b7f-d26a-4013-5c44-a745a3a17f99&SI=NonSentItems&SLSync=F'
  ),
  externalLink(
    'Technology Toolbox',
    'https://usahs.sharepoint.com/sites/USAHSStudentResources/SitePages/Navigating-the-Online-Learning-Environment.aspx'
  ),
  {
    id: 'library',
    label: 'Library',
    links: [
      externalLink('Library Resources', 'https://library.usa.edu/'),
      externalLink('SOAR@USA', 'https://soar.usa.edu/'),
      externalLink('Student Journal of Occupational Therapy', 'https://soar.usa.edu/sjot'),
      externalLink(
        'Scholarly Skills Community',
        'https://class.usa.edu/webapps/blackboard/content/listContentEditable.jsp?content_id=_2233388_1&course_id=_17671_1'
      )
    ]
  },
  externalLink('Career Services', 'https://my.usa.edu/ICS/Career_Services/'),
  externalLink('Student Services', 'https://my.usa.edu/ICS/Student_Services/')
];